<section class="header">
  <div routerLink="/" class="header__left">
    <div class="logo__img">
      <img src="assets/images/logo.svg" alt="" />
    </div>
    <div class="logo__name">TA DECIDE</div>
  </div>

  <div class="header__right">
    <div class="info">
      <a class="link" [routerLink]="['/institutions']" routerLinkActive="router-link-active"
        >All Institutions</a
      >
    </div>
    <div class="info">
      <mat-icon class="show-xs" [svgIcon]="'add-icon'"></mat-icon>
      <a class="link" [routerLink]="['/compare']"> Compare: </a>
      <b class="value px-xs">{{ (compare$ | async)?.length }}/3</b>
    </div>
    <div class="info" (click)="showSaved()">
      <mat-icon [svgIcon]="'save-icon'"></mat-icon>
      <a class="link"> Saved: </a> <b class="value">{{ (saved$ | async)?.length }}</b>
    </div>
  </div>
</section>
